var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36.375H21.25C21.25 38.4375 19.5625 40.125 17.5 40.125C15.4375 40.125 13.75 38.4375 13.75 36.375ZM34.375 32.625V34.5H0.625V32.625L4.375 28.875V17.625C4.375 11.8125 8.125 6.75 13.75 5.0625V4.5C13.75 2.4375 15.4375 0.75 17.5 0.75C19.5625 0.75 21.25 2.4375 21.25 4.5V5.0625C26.875 6.75 30.625 11.8125 30.625 17.625V28.875L34.375 32.625ZM26.875 17.625C26.875 12.375 22.75 8.25 17.5 8.25C12.25 8.25 8.125 12.375 8.125 17.625V30.75H26.875V17.625Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.1754120b7999eccc78c42f3c071cfd9a.svg";
export { ForwardRef as ReactComponent };